import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../../../../components/modal'

const PaymentDetailModal = ({
    isOpen,
    onClose,
    payment,
    agentName,
    t,
    formatCurrency,
    formatDate,
    getPaymentMethodLabel,
    currency
}) => {
    const normalizeStatus = (value) => {
        if (!value) return 'unknown'
        return value
            .toString()
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '_')
            .replace(/-+/g, '_')
    }

    const getStatusLabel = (value) => {
        if (!value) return '-'
        const statusKeyMap = {
            pending: 'AGENT_COMMISSIONS_STATUS_PENDING',
            approved: 'AGENT_COMMISSIONS_STATUS_APPROVED',
            accepted: 'AGENT_COMMISSIONS_STATUS_APPROVED',
            rejected: 'AGENT_COMMISSIONS_STATUS_REJECTED',
            cancelled: 'AGENT_COMMISSIONS_STATUS_CANCELLED',
            canceled: 'AGENT_COMMISSIONS_STATUS_CANCELLED',
            paid: 'AGENT_COMMISSIONS_STATUS_PAID',
            unpaid: 'AGENT_COMMISSIONS_STATUS_UNPAID',
            active: 'AGENT_COMMISSIONS_STATUS_ACTIVE',
            inactive: 'AGENT_COMMISSIONS_STATUS_INACTIVE',
            completed: 'AGENT_COMMISSIONS_STATUS_COMPLETED'
        }
        const key = statusKeyMap[normalizeStatus(value)]
        return key ? t(key) : value
    }

    const statusValue = payment?.status
    const statusClass = normalizeStatus(statusValue)
    const statusLabel = getStatusLabel(statusValue)

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={t('AGENT_COMMISSIONS_PAYMENT_DETAIL_TITLE')}
            subtitle={agentName}
            icon="zmdi-money"
            size="medium"
            className="commission-detail-modal"
        >
            <div className="detail-modal-content">
                <div className="detail-summary">
                    <div className="summary-main">
                        <span className="summary-label">{t('AGENT_COMMISSIONS_TABLE_AMOUNT')}</span>
                        <span className="summary-value">
                            {formatCurrency(payment?.amount, payment?.currency || currency)}
                        </span>
                    </div>
                    <div className="summary-meta">
                        <span className="meta-chip">
                            <i className="zmdi zmdi-calendar"></i>
                            {formatDate(payment?.paymentDate || payment?.date)}
                        </span>
                        <span className="meta-chip">
                            <i className="zmdi zmdi-card"></i>
                            {getPaymentMethodLabel(payment?.paymentMethod || payment?.method)}
                        </span>
                        <span className={`meta-chip status-chip status-${statusClass}`}>
                            <i className="zmdi zmdi-info-outline"></i>
                            {statusLabel}
                        </span>
                    </div>
                </div>

                <div className="detail-section-card">
                    <h6 className="detail-section-title">
                        <i className="zmdi zmdi-file-text"></i>
                        {t('AGENT_COMMISSIONS_TABLE_REFERENCE')}
                    </h6>
                    <div className="detail-grid compact">
                        <div className="detail-item">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_REFERENCE')}</span>
                            <span className="detail-value">{payment?.referenceNumber || '-'}</span>
                        </div>
                    </div>
                </div>

                <div className="detail-section-card">
                    <h6 className="detail-section-title">
                        <i className="zmdi zmdi-comment-text"></i>
                        {t('AGENT_COMMISSIONS_TABLE_DESCRIPTION')}
                    </h6>
                    <div className="detail-grid">
                        <div className="detail-item full">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_DESCRIPTION')}</span>
                            <span className="detail-value">{payment?.description || '-'}</span>
                        </div>
                        <div className="detail-item full">
                            <span className="detail-label">{t('AGENT_COMMISSIONS_TABLE_NOTES')}</span>
                            <span className="detail-value">{payment?.notes || '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

PaymentDetailModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    payment: PropTypes.object,
    agentName: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    formatCurrency: PropTypes.func.isRequired,
    formatDate: PropTypes.func.isRequired,
    getPaymentMethodLabel: PropTypes.func.isRequired,
    currency: PropTypes.string
}

export default PaymentDetailModal

